var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/*eslint no-useless-escape: 0*/
import React, { useState, useEffect, useMemo } from 'react';
import { Box, Tab, Tabs, Button, Typography, MenuItem, Grid, Table, TableHead, TableCell, TableRow, TableBody, Paper, TableContainer, IconButton, Checkbox, FormControlLabel, Divider, } from '@mui/material';
import { MODOS, MENSAGENS } from '../../../utils';
import { ROUTES, FUNCIONALIDADES, PAGINAS } from '../../../routes';
import ContainerPainel from '../../../components/container_painel';
import { useAuth } from '../../../contexts/auth/AuthContext';
import { BoxPrincipal, BoxBotoes } from '../../../components/form_box';
import Loading from '../../../components/loading';
import { useNavigate, useParams } from 'react-router-dom';
import { BotaoSalvar, BotaoFechar, BotaoEditar, BotaoAuxiliar, BotaoExcluir } from '../../../components/botoes';
import { InputDados } from '../../../components/input_dados';
import RangeDatePicker from '../../../components/range_date_picker';
import { Replay, DeleteOutline as DeleteOutlineIcon, Add as AddIcon, Refresh as RefreshIcon } from '@mui/icons-material';
import { alterarParametrosFolha, cadastrarParametrosParametrosFolha, excluirParametrosParametrosFolha, getParametrosFolha, getPeriodosFechamento, adicionarPeriodoFechamento, excluirPeriodoFechamento, calcularDiasUteisRegionalidade, getFeriados, cadastrarFeriado, excluirFeriado, STATUS_API, } from './parametros_folhas.service';
import { getEstadosAtivos, getCidadesAtivos } from '../../../api';
var ABRANGENCIAS = ['Federal', 'Estadual', 'Municipal'];
var MESES = [
    { key: 'janeiro', label: 'Janeiro' },
    { key: 'fevereiro', label: 'Fevereiro' },
    { key: 'marco', label: 'Março' },
    { key: 'abril', label: 'Abril' },
    { key: 'maio', label: 'Maio' },
    { key: 'junho', label: 'Junho' },
    { key: 'julho', label: 'Julho' },
    { key: 'agosto', label: 'Agosto' },
    { key: 'setembro', label: 'Setembro' },
    { key: 'outubro', label: 'Outubro' },
    { key: 'novembro', label: 'Novembro' },
    { key: 'dezembro', label: 'Dezembro' },
];
export var ParametrosParametrosFolhasEditar = function () {
    var _a = useAuth(), addMensagem = _a.addMensagem, getAcoesFuncionalidade = _a.getAcoesFuncionalidade;
    var AcoesFuncionalidade = useMemo(function () { return getAcoesFuncionalidade(FUNCIONALIDADES.PARAMETROS_FOLHAS); }, [getAcoesFuncionalidade]);
    var navigate = useNavigate();
    var _b = useState(true), loading = _b[0], setLoading = _b[1];
    var _c = useState(true), LoadingInicio = _c[0], setLoadingInicio = _c[1];
    var _d = useState(0), AbaAtiva = _d[0], setAbaAtiva = _d[1];
    var _f = useParams(), id = _f.id, modo = _f.modo;
    var _g = useState(''), Nome = _g[0], setNome = _g[1];
    var _h = useState(new Date().getFullYear().toString()), AnoReferencia = _h[0], setAnoReferencia = _h[1];
    var _j = useState(false), CalculaProporcionalDiasTrabalhados = _j[0], setCalculaProporcionalDiasTrabalhados = _j[1];
    var _k = useState(false), CalculaFolhaComplementar = _k[0], setCalculaFolhaComplementar = _k[1];
    var _l = useState(false), PermiteReabrirFolha = _l[0], setPermiteReabrirFolha = _l[1];
    var _m = useState(''), DataFechamentoFolha = _m[0], setDataFechamentoFolha = _m[1];
    var _o = useState({}), DiasUteis = _o[0], setDiasUteis = _o[1];
    var _p = useState('Ativo'), Situacao = _p[0], setSituacao = _p[1];
    // Períodos de fechamento
    var _q = useState([]), Periodos = _q[0], setPeriodos = _q[1];
    var _r = useState(), PeriodoSelecionado = _r[0], setPeriodoSelecionado = _r[1];
    var _s = useState(''), NovoInicio = _s[0], setNovoInicio = _s[1];
    var _t = useState(''), NovoFim = _t[0], setNovoFim = _t[1];
    // Regionalidade (visualizar dias úteis)
    var _u = useState('geral'), RegionalidadeSelecionada = _u[0], setRegionalidadeSelecionada = _u[1];
    // Feriados (calendário global)
    var _v = useState([]), ListaFeriados = _v[0], setListaFeriados = _v[1];
    var _w = useState([]), EstadosDisponiveis = _w[0], setEstadosDisponiveis = _w[1];
    var _x = useState([]), CidadesFeriado = _x[0], setCidadesFeriado = _x[1];
    var _y = useState(''), FeriadoDescricao = _y[0], setFeriadoDescricao = _y[1];
    var _z = useState(''), FeriadoData = _z[0], setFeriadoData = _z[1];
    var _0 = useState('Federal'), FeriadoAbrangencia = _0[0], setFeriadoAbrangencia = _0[1];
    var _1 = useState(''), FeriadoUF = _1[0], setFeriadoUF = _1[1];
    var _2 = useState(''), FeriadoCidade = _2[0], setFeriadoCidade = _2[1];
    var _3 = useState(false), FeriadoSabadoTrabalhado = _3[0], setFeriadoSabadoTrabalhado = _3[1];
    var REGISTRO_INATIVO = Situacao == 'Inativo';
    var DESABILITAR_CAMPOS = modo == MODOS.VISUALIZAR || modo == MODOS.EXCLUIR || REGISTRO_INATIVO;
    // Calcula dias úteis (seg-sex) de um mês/ano sem considerar feriados.
    var calcularDiasUteisDoMes = function (ano, mes) {
        var diasNoMes = new Date(ano, mes, 0).getDate();
        var diasUteis = 0;
        for (var dia = 1; dia <= diasNoMes; dia++) {
            var diaDaSemana = new Date(ano, mes - 1, dia).getDay();
            if (diaDaSemana !== 0 && diaDaSemana !== 6)
                diasUteis++;
        }
        return diasUteis;
    };
    var preencherDiasUteisAutomatico = function (ano) {
        var novo = {};
        MESES.forEach(function (m, idx) {
            novo[m.key] = calcularDiasUteisDoMes(ano, idx + 1).toString();
        });
        setDiasUteis(novo);
    };
    var aplicarDiasUteis = function (origem) {
        var novo = {};
        MESES.forEach(function (m) {
            var valor = origem === null || origem === void 0 ? void 0 : origem["qtd_dias_uteis_".concat(m.key)];
            novo[m.key] = valor != null ? valor.toString() : '';
        });
        setDiasUteis(novo);
    };
    useEffect(function () {
        carregarDados();
        return function () { };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(function () {
        if (modo === MODOS.CADASTRAR && AnoReferencia) {
            var ano = Number.parseInt(AnoReferencia, 10);
            if (!Number.isNaN(ano) && ano > 2000)
                preencherDiasUteisAutomatico(ano);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [AnoReferencia]);
    var carregarDados = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, estados, feriados, e_1, ParametrosFolhaAux;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, Promise.all([getEstadosAtivos(), getFeriados()])];
                case 1:
                    _a = _c.sent(), estados = _a[0], feriados = _a[1];
                    setEstadosDisponiveis(Array.isArray(estados) ? estados : []);
                    setListaFeriados(Array.isArray(feriados) ? feriados : []);
                    return [3 /*break*/, 3];
                case 2:
                    e_1 = _c.sent();
                    setEstadosDisponiveis([]);
                    setListaFeriados([]);
                    return [3 /*break*/, 3];
                case 3:
                    if (!id) return [3 /*break*/, 6];
                    return [4 /*yield*/, getParametrosFolha(id)];
                case 4:
                    ParametrosFolhaAux = _c.sent();
                    if (ParametrosFolhaAux.Status == STATUS_API.ERRO) {
                        alert(ParametrosFolhaAux.Mensagem);
                        setLoadingInicio(false);
                        setLoading(false);
                        return [2 /*return*/];
                    }
                    setNome((_b = ParametrosFolhaAux.nome) !== null && _b !== void 0 ? _b : '');
                    setAnoReferencia(ParametrosFolhaAux.ano_referencia);
                    setCalculaProporcionalDiasTrabalhados(ParametrosFolhaAux.calculo_proporcional_dias_trabalhandos);
                    setCalculaFolhaComplementar(ParametrosFolhaAux.calcula_folha_complementar);
                    setPermiteReabrirFolha(ParametrosFolhaAux.permite_reabrir_folha);
                    setDataFechamentoFolha(ParametrosFolhaAux.data_fechamento_folha);
                    setSituacao(ParametrosFolhaAux.situacao);
                    aplicarDiasUteis(ParametrosFolhaAux);
                    return [4 /*yield*/, carregarPeriodos()];
                case 5:
                    _c.sent();
                    if (modo == MODOS.ALTERAR && ParametrosFolhaAux.situacao == 'Inativo') {
                        alert('Não é permitido editar registros inativos. O registro será exibido em modo de visualização.');
                        navigate("".concat(ROUTES.PARAMETROS_FOLHAS, "/").concat(id, "/").concat(MODOS.VISUALIZAR));
                        return [2 /*return*/];
                    }
                    _c.label = 6;
                case 6:
                    setLoadingInicio(false);
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var carregarPeriodos = function () { return __awaiter(void 0, void 0, void 0, function () {
        var Resp;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!id)
                        return [2 /*return*/];
                    return [4 /*yield*/, getPeriodosFechamento(id)];
                case 1:
                    Resp = _a.sent();
                    setPeriodos(Array.isArray(Resp) ? Resp : []);
                    return [2 /*return*/];
            }
        });
    }); };
    var carregarFeriados = function () { return __awaiter(void 0, void 0, void 0, function () {
        var Resp;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getFeriados()];
                case 1:
                    Resp = _a.sent();
                    setListaFeriados(Array.isArray(Resp) ? Resp : []);
                    return [2 /*return*/];
            }
        });
    }); };
    // ===== PERÍODOS =====
    // O período é um ciclo mensal definido pelo DIA de início/fim. As datas
    // selecionadas no calendário são convertidas para uma data representativa
    // (mês/ano atual + o dia do período) apenas para exibição.
    var diaParaData = function (dia) {
        var hoje = new Date();
        var ano = hoje.getFullYear();
        var mes = String(hoje.getMonth() + 1).padStart(2, '0');
        return "".concat(ano, "-").concat(mes, "-").concat(String(dia).padStart(2, '0'));
    };
    var diaDaData = function (dataStr) {
        if (!dataStr)
            return Number.NaN;
        var partes = dataStr.split('-');
        return Number.parseInt(partes[2], 10);
    };
    var selecionarPeriodo = function (periodoId) {
        setPeriodoSelecionado(periodoId);
        var p = Periodos.find(function (x) { return x.id == periodoId; });
        if (p) {
            setNovoInicio(diaParaData(p.dia_inicio));
            setNovoFim(diaParaData(p.dia_fim));
        }
    };
    var adicionarPeriodo = function () { return __awaiter(void 0, void 0, void 0, function () {
        var ini, fim, Resp;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    ini = diaDaData(NovoInicio);
                    fim = diaDaData(NovoFim);
                    if (Number.isNaN(ini) || Number.isNaN(fim)) {
                        alert('Selecione a data de início e a data de fim do período.');
                        return [2 /*return*/];
                    }
                    setLoading(true);
                    return [4 /*yield*/, adicionarPeriodoFechamento(id !== null && id !== void 0 ? id : '', { dia_inicio: ini, dia_fim: fim })];
                case 1:
                    Resp = _b.sent();
                    setLoading(false);
                    if ((Resp === null || Resp === void 0 ? void 0 : Resp.Status) === 'OK') {
                        setNovoInicio('');
                        setNovoFim('');
                        setPeriodoSelecionado(undefined);
                        carregarPeriodos();
                    }
                    else {
                        alert((_a = Resp === null || Resp === void 0 ? void 0 : Resp.Mensagem) !== null && _a !== void 0 ? _a : 'Erro ao adicionar período.');
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var excluirPeriodoSelecionado = function () { return __awaiter(void 0, void 0, void 0, function () {
        var Resp;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!PeriodoSelecionado) {
                        alert('Selecione um período cadastrado para excluir.');
                        return [2 /*return*/];
                    }
                    if (!confirm('Deseja excluir o período selecionado?'))
                        return [2 /*return*/];
                    setLoading(true);
                    return [4 /*yield*/, excluirPeriodoFechamento(String(PeriodoSelecionado))];
                case 1:
                    Resp = _b.sent();
                    setLoading(false);
                    if ((Resp === null || Resp === void 0 ? void 0 : Resp.Status) === 'OK') {
                        setPeriodoSelecionado(undefined);
                        setNovoInicio('');
                        setNovoFim('');
                        carregarPeriodos();
                    }
                    else {
                        alert((_a = Resp === null || Resp === void 0 ? void 0 : Resp.Mensagem) !== null && _a !== void 0 ? _a : 'Erro ao excluir período.');
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    // ===== REGIONALIDADE / DIAS ÚTEIS =====
    var opcoesRegionalidade = useMemo(function () {
        var opcoes = [{ value: 'geral', label: 'Geral (Brasil)', uf: null, cidade_id: null }];
        var ufs = new Set();
        var cidades = new Map();
        ListaFeriados.forEach(function (f) {
            if (f.abrangencia === 'Estadual' && f.uf)
                ufs.add(f.uf);
            if (f.abrangencia === 'Municipal' && f.cidade_id)
                cidades.set(f.cidade_id, { uf: f.uf, nome: f.cidade_nome });
        });
        ufs.forEach(function (uf) { return opcoes.push({ value: "uf:".concat(uf), label: "".concat(uf, " (Estadual)"), uf: uf, cidade_id: null }); });
        cidades.forEach(function (v, cidadeId) { return opcoes.push({ value: "cidade:".concat(cidadeId), label: "".concat(v.uf, " - ").concat(v.nome), uf: v.uf, cidade_id: cidadeId }); });
        return opcoes;
    }, [ListaFeriados]);
    var atualizarDiasUteis = function () { return __awaiter(void 0, void 0, void 0, function () {
        var opt, Resp;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    opt = opcoesRegionalidade.find(function (o) { return o.value === RegionalidadeSelecionada; }) || opcoesRegionalidade[0];
                    setLoading(true);
                    return [4 /*yield*/, calcularDiasUteisRegionalidade(id !== null && id !== void 0 ? id : '', opt.uf, opt.cidade_id)];
                case 1:
                    Resp = _a.sent();
                    setLoading(false);
                    if ((Resp === null || Resp === void 0 ? void 0 : Resp.Status) === STATUS_API.ERRO) {
                        alert(Resp.Mensagem);
                        return [2 /*return*/];
                    }
                    aplicarDiasUteis(Resp);
                    return [2 /*return*/];
            }
        });
    }); };
    // ===== FERIADOS =====
    var onChangeAbrangencia = function (valor) {
        setFeriadoAbrangencia(valor);
        if (valor === 'Federal') {
            setFeriadoUF('');
            setFeriadoCidade('');
            setCidadesFeriado([]);
        }
    };
    var onChangeEstadoFeriado = function (uf) { return __awaiter(void 0, void 0, void 0, function () {
        var cidades;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setFeriadoUF(uf);
                    setFeriadoCidade('');
                    if (!uf) return [3 /*break*/, 2];
                    return [4 /*yield*/, getCidadesAtivos(uf)];
                case 1:
                    cidades = _a.sent();
                    setCidadesFeriado(Array.isArray(cidades) ? cidades : []);
                    return [3 /*break*/, 3];
                case 2:
                    setCidadesFeriado([]);
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var limparFeriado = function () {
        setFeriadoDescricao('');
        setFeriadoData('');
        setFeriadoAbrangencia('Federal');
        setFeriadoUF('');
        setFeriadoCidade('');
        setCidadesFeriado([]);
        setFeriadoSabadoTrabalhado(false);
    };
    var salvarFeriado = function () { return __awaiter(void 0, void 0, void 0, function () {
        var partes, dia, mes, cidadeObj, Dados, Resp;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!FeriadoDescricao || FeriadoDescricao.trim() == '') {
                        alert("Descri\u00E7\u00E3o do feriado ".concat(MENSAGENS.PREENCHIMENTO_OBRIGATORIO));
                        return [2 /*return*/];
                    }
                    partes = (FeriadoData || '').split('/');
                    dia = Number.parseInt(partes[0], 10);
                    mes = Number.parseInt(partes[1], 10);
                    if (Number.isNaN(dia) || dia < 1 || dia > 31 || Number.isNaN(mes) || mes < 1 || mes > 12) {
                        alert('Data do feriado inválida. Utilize o formato DD/MM.');
                        return [2 /*return*/];
                    }
                    if (!FeriadoAbrangencia) {
                        alert("Abrang\u00EAncia ".concat(MENSAGENS.PREENCHIMENTO_OBRIGATORIO));
                        return [2 /*return*/];
                    }
                    if ((FeriadoAbrangencia === 'Estadual' || FeriadoAbrangencia === 'Municipal') && !FeriadoUF) {
                        alert("Estado ".concat(MENSAGENS.PREENCHIMENTO_OBRIGATORIO));
                        return [2 /*return*/];
                    }
                    if (FeriadoAbrangencia === 'Municipal' && !FeriadoCidade) {
                        alert("Cidade ".concat(MENSAGENS.PREENCHIMENTO_OBRIGATORIO));
                        return [2 /*return*/];
                    }
                    cidadeObj = CidadesFeriado.find(function (c) { return c.id == FeriadoCidade; });
                    Dados = {
                        descricao: FeriadoDescricao.trim(),
                        dia: dia,
                        mes: mes,
                        abrangencia: FeriadoAbrangencia,
                        uf: FeriadoAbrangencia === 'Federal' ? null : FeriadoUF,
                        cidade_id: FeriadoAbrangencia === 'Municipal' ? Number(FeriadoCidade) : null,
                        cidade_nome: FeriadoAbrangencia === 'Municipal' ? (_a = cidadeObj === null || cidadeObj === void 0 ? void 0 : cidadeObj.nome) !== null && _a !== void 0 ? _a : null : null,
                        sabado_trabalhado: FeriadoSabadoTrabalhado,
                    };
                    setLoading(true);
                    return [4 /*yield*/, cadastrarFeriado(Dados)];
                case 1:
                    Resp = _c.sent();
                    setLoading(false);
                    if ((Resp === null || Resp === void 0 ? void 0 : Resp.Status) === 'OK') {
                        limparFeriado();
                        carregarFeriados();
                        addMensagem === null || addMensagem === void 0 ? void 0 : addMensagem('Feriado salvo no calendário.');
                    }
                    else {
                        alert((_b = Resp === null || Resp === void 0 ? void 0 : Resp.Mensagem) !== null && _b !== void 0 ? _b : 'Erro ao salvar feriado.');
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var excluirFeriadoLinha = function (feriadoId) { return __awaiter(void 0, void 0, void 0, function () {
        var Resp;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!confirm('Deseja excluir este feriado?'))
                        return [2 /*return*/];
                    setLoading(true);
                    return [4 /*yield*/, excluirFeriado(String(feriadoId))];
                case 1:
                    Resp = _b.sent();
                    setLoading(false);
                    if ((Resp === null || Resp === void 0 ? void 0 : Resp.Status) === 'OK') {
                        carregarFeriados();
                    }
                    else {
                        alert((_a = Resp === null || Resp === void 0 ? void 0 : Resp.Mensagem) !== null && _a !== void 0 ? _a : 'Erro ao excluir feriado.');
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var getLocalFeriado = function (f) {
        var _a, _b;
        if (f.abrangencia === 'Federal')
            return 'Brasil';
        if (f.abrangencia === 'Estadual')
            return (_a = f.uf) !== null && _a !== void 0 ? _a : '—';
        return "".concat((_b = f.uf) !== null && _b !== void 0 ? _b : '').concat(f.cidade_nome ? " - ".concat(f.cidade_nome) : '');
    };
    var pad2 = function (n) { return String(n).padStart(2, '0'); };
    // ===== SALVAR PARÂMETRO =====
    var validarDados = function () {
        if (!Nome || Nome.trim() == '') {
            alert("Nome ".concat(MENSAGENS.PREENCHIMENTO_OBRIGATORIO));
            return false;
        }
        if (!AnoReferencia || AnoReferencia.trim() == '') {
            alert("Ano de refer\u00EAncia ".concat(MENSAGENS.PREENCHIMENTO_OBRIGATORIO));
            return false;
        }
        for (var _i = 0, MESES_1 = MESES; _i < MESES_1.length; _i++) {
            var m = MESES_1[_i];
            var valor = DiasUteis[m.key];
            if (!valor || valor.trim() == '') {
                alert("Quantidade de dias \u00FAteis de ".concat(m.label, " ").concat(MENSAGENS.PREENCHIMENTO_OBRIGATORIO));
                return false;
            }
            var num = Number.parseInt(valor, 10);
            if (Number.isNaN(num) || num < 1 || num > 31) {
                alert("Quantidade de dias \u00FAteis de ".concat(m.label, " deve ser um valor entre 1 e 31."));
                return false;
            }
        }
        return true;
    };
    var salvarDados = function () { return __awaiter(void 0, void 0, void 0, function () {
        var Dados, Resp, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!validarDados())
                        return [2 /*return*/];
                    if (!confirm('Atenção: Ao confirmar as edições, todas as folhas deverão ser recalculadas para que as alterações tenham efeito.'))
                        return [2 /*return*/];
                    setLoading(true);
                    Dados = {
                        nome: Nome,
                        ano_referencia: AnoReferencia,
                        calculo_proporcional_dias_trabalhandos: CalculaProporcionalDiasTrabalhados,
                        calcula_folha_complementar: CalculaFolhaComplementar,
                        permite_reabrir_folha: PermiteReabrirFolha,
                        data_fechamento_folha: DataFechamentoFolha,
                        situacao: Situacao,
                    };
                    MESES.forEach(function (m) {
                        Dados["qtd_dias_uteis_".concat(m.key)] = Number.parseInt(DiasUteis[m.key], 10);
                    });
                    _a = modo;
                    switch (_a) {
                        case MODOS.CADASTRAR: return [3 /*break*/, 1];
                        case MODOS.ALTERAR: return [3 /*break*/, 3];
                    }
                    return [3 /*break*/, 5];
                case 1: return [4 /*yield*/, cadastrarParametrosParametrosFolha(Dados)];
                case 2:
                    Resp = _b.sent();
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, alterarParametrosFolha(Dados, id !== null && id !== void 0 ? id : '')];
                case 4:
                    Resp = _b.sent();
                    return [3 /*break*/, 5];
                case 5:
                    setLoading(false);
                    if ((Resp === null || Resp === void 0 ? void 0 : Resp.Status) == 'OK') {
                        addMensagem === null || addMensagem === void 0 ? void 0 : addMensagem(modo == MODOS.CADASTRAR ? MENSAGENS.REGISTRO_CADASTRADO_SUCESSO : MENSAGENS.REGISTRO_ALTERADO_SUCESSO);
                        navigate(ROUTES.PARAMETROS_FOLHAS);
                    }
                    else if (Resp) {
                        alert(Resp.Mensagem);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var editarRegistro = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (REGISTRO_INATIVO)
                return [2 /*return*/];
            navigate("".concat(ROUTES.PARAMETROS_FOLHAS, "/").concat(id, "/").concat(MODOS.ALTERAR));
            return [2 /*return*/];
        });
    }); };
    var setDiaUtil = function (key, valor) {
        setDiasUteis(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[key] = valor, _a)));
        });
    };
    var excluirRegistro = function () { return __awaiter(void 0, void 0, void 0, function () {
        var resp;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!confirm(MENSAGENS.EXCLUIR_REGISTRO))
                        return [2 /*return*/];
                    setLoading(true);
                    return [4 /*yield*/, excluirParametrosParametrosFolha(id !== null && id !== void 0 ? id : '')];
                case 1:
                    resp = _a.sent();
                    setLoading(false);
                    if ((resp === null || resp === void 0 ? void 0 : resp.Status) === 'OK') {
                        if (addMensagem)
                            addMensagem(MENSAGENS.REGISTRO_EXCLUIDO_SUCESSO);
                        navigate(ROUTES.PARAMETROS_FOLHAS);
                    }
                    else if (resp) {
                        alert(resp.Mensagem);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    return (_jsx(ContainerPainel, __assign({ modo: modo, pagina_acima: PAGINAS.PARAMETROS_FOLHAS, pagina_especifica_permissao: FUNCIONALIDADES.PARAMETROS_FOLHAS, link_pagina_acima: ROUTES.PARAMETROS_FOLHAS }, { children: _jsxs(BoxPrincipal, __assign({ sx: { width: '90%' } }, { children: [!LoadingInicio && (_jsxs(_Fragment, { children: [_jsxs(Tabs, __assign({ value: AbaAtiva, onChange: function (_e, v) { return setAbaAtiva(v); }, sx: { mb: 2 } }, { children: [_jsx(Tab, { label: 'DADOS GERAIS' }), _jsx(Tab, { label: 'GEST\u00C3O DE FERIADOS' })] })), AbaAtiva === 0 && (_jsxs(Box, __assign({ sx: { mt: 1 } }, { children: [id && (_jsxs(Box, __assign({ sx: { mb: 3 } }, { children: [_jsx(Typography, __assign({ variant: 'subtitle1', sx: { fontWeight: 600, mb: 1 } }, { children: "Gerenciamento de Per\u00EDodos de Fechamento" })), _jsxs(Grid, __assign({ container: true, spacing: 2, alignItems: 'flex-end' }, { children: [_jsxs(Grid, __assign({ item: true, xs: 12, sm: 4, display: 'flex', alignItems: 'flex-end', gap: 1 }, { children: [_jsxs(InputDados, __assign({ select: true, id: 'periodos_cadastrados', label: 'Per\u00EDodos Cadastrados', value: PeriodoSelecionado !== null && PeriodoSelecionado !== void 0 ? PeriodoSelecionado : '', onChange: function (event) { return selecionarPeriodo(event.target.value); }, disabled: DESABILITAR_CAMPOS }, { children: [_jsx(MenuItem, __assign({ value: '' }, { children: _jsx("em", { children: "Selecione" }) })), Periodos.map(function (p) { return (_jsx(MenuItem, __assign({ value: p.id }, { children: "".concat(p.dia_inicio, " a ").concat(p.dia_fim) }), p.id)); })] })), _jsx(IconButton, __assign({ "aria-label": 'excluir per\u00EDodo', color: 'error', onClick: excluirPeriodoSelecionado, disabled: DESABILITAR_CAMPOS || !PeriodoSelecionado }, { children: _jsx(DeleteOutlineIcon, {}) }))] })), _jsx(Grid, __assign({ item: true, xs: 12, sm: 5 }, { children: _jsx(RangeDatePicker, { label: 'Novo Per\u00EDodo (In\u00EDcio \u2192 Fim)', inicio: NovoInicio || null, fim: NovoFim || null, onChange: function (ini, fim) {
                                                            setNovoInicio(ini !== null && ini !== void 0 ? ini : '');
                                                            setNovoFim(fim !== null && fim !== void 0 ? fim : '');
                                                        }, disabled: DESABILITAR_CAMPOS }) })), _jsx(Grid, __assign({ item: true, xs: 12, sm: 3 }, { children: _jsx(BotaoAuxiliar, __assign({ startIcon: _jsx(AddIcon, {}), backgroundColor: 'principal.main', onClick: adicionarPeriodo, disabled: DESABILITAR_CAMPOS }, { children: "Adicionar Per\u00EDodo" })) }))] })), _jsx(Divider, { sx: { mt: 3 } })] }))), _jsxs(Grid, __assign({ container: true, spacing: 2 }, { children: [_jsx(Grid, __assign({ item: true, xs: 12, sm: 3 }, { children: _jsx(InputDados, { id: 'ano_referencia', label: 'Ano de refer\u00EAncia', value: AnoReferencia, onChange: function (event) { return setAnoReferencia(event.target.value); }, disabled: true }) })), _jsx(Grid, __assign({ item: true, xs: 12, sm: 6 }, { children: _jsx(InputDados, { id: 'nome', label: 'Nome do Par\u00E2metro', value: Nome, onChange: function (event) { return setNome(event.target.value); }, required: true, disabled: DESABILITAR_CAMPOS }) })), _jsx(Grid, { item: true, xs: 12, sm: 3 }), _jsx(Grid, __assign({ item: true, xs: 12, sm: 3 }, { children: _jsxs(InputDados, __assign({ select: true, id: 'calcula_folha_complementar', label: 'Calcula folha complementar', value: CalculaFolhaComplementar, onChange: function (event) { return setCalculaFolhaComplementar(event.target.value === 'true'); }, required: true, disabled: DESABILITAR_CAMPOS }, { children: [_jsx(MenuItem, __assign({ value: 'true' }, { children: "Sim" })), _jsx(MenuItem, __assign({ value: 'false' }, { children: "N\u00E3o" }))] })) })), _jsx(Grid, __assign({ item: true, xs: 12, sm: 3 }, { children: _jsxs(InputDados, __assign({ select: true, id: 'permite_reabrir_folha', label: 'Permite reabrir folha', value: PermiteReabrirFolha, onChange: function (event) { return setPermiteReabrirFolha(event.target.value === 'true'); }, required: true, disabled: DESABILITAR_CAMPOS }, { children: [_jsx(MenuItem, __assign({ value: 'true' }, { children: "Sim" })), _jsx(MenuItem, __assign({ value: 'false' }, { children: "N\u00E3o" }))] })) })), _jsx(Grid, __assign({ item: true, xs: 12, sm: 3 }, { children: _jsxs(InputDados, __assign({ select: true, id: 'calculo_proporcional_dias_trabalhandos', label: 'Calcula proporcional dias trabalhados', value: CalculaProporcionalDiasTrabalhados, onChange: function (event) { return setCalculaProporcionalDiasTrabalhados(event.target.value === 'true'); }, required: true, disabled: DESABILITAR_CAMPOS }, { children: [_jsx(MenuItem, __assign({ value: 'true' }, { children: "Sim" })), _jsx(MenuItem, __assign({ value: 'false' }, { children: "N\u00E3o" }))] })) }))] })), _jsxs(Box, __assign({ sx: { mt: 3 } }, { children: [_jsxs(Grid, __assign({ container: true, spacing: 2, alignItems: 'flex-end' }, { children: [_jsx(Grid, __assign({ item: true, xs: 12, sm: 5 }, { children: _jsx(InputDados, __assign({ select: true, id: 'regionalidade', label: 'Visualizar Dias \u00DAteis por Regionalidade', value: RegionalidadeSelecionada, onChange: function (event) { return setRegionalidadeSelecionada(event.target.value); }, disabled: DESABILITAR_CAMPOS }, { children: opcoesRegionalidade.map(function (o) { return (_jsx(MenuItem, __assign({ value: o.value }, { children: o.label }), o.value)); }) })) })), _jsxs(Grid, __assign({ item: true, xs: 12, sm: 4 }, { children: [id && !DESABILITAR_CAMPOS && (_jsx(BotaoAuxiliar, __assign({ startIcon: _jsx(RefreshIcon, {}), backgroundColor: 'primary.main', onClick: atualizarDiasUteis }, { children: "Atualizar Dias \u00DAteis" }))), modo === MODOS.CADASTRAR && (_jsx(Button, __assign({ size: 'small', variant: 'outlined', startIcon: _jsx(Replay, {}), onClick: function () {
                                                                var ano = Number.parseInt(AnoReferencia, 10);
                                                                if (!Number.isNaN(ano))
                                                                    preencherDiasUteisAutomatico(ano);
                                                            } }, { children: "Recalcular (seg\u2013sex)" })))] }))] })), _jsx(Typography, __assign({ variant: 'caption', color: 'textSecondary' }, { children: "Contagem de dias \u00FAteis (considerando feriados cadastrados)" }))] })), _jsx(Grid, __assign({ container: true, spacing: 2, sx: { mt: 0.5 } }, { children: MESES.map(function (m) {
                                        var _a;
                                        return (_jsx(Grid, __assign({ item: true, xs: 6, sm: 3 }, { children: _jsx(InputDados, { id: "qtd_dias_uteis_".concat(m.key), label: m.label, value: (_a = DiasUteis[m.key]) !== null && _a !== void 0 ? _a : '', mask: '99', onChange: function (event) { return setDiaUtil(m.key, event.target.value); }, required: true, disabled: DESABILITAR_CAMPOS }) }), m.key));
                                    }) }))] }))), AbaAtiva === 1 && (_jsxs(Box, __assign({ sx: { mt: 1 } }, { children: [_jsxs(Grid, __assign({ container: true, spacing: 2, alignItems: 'flex-end' }, { children: [_jsx(Grid, __assign({ item: true, xs: 12, sm: 4 }, { children: _jsx(InputDados, { id: 'feriado_descricao', label: 'Descri\u00E7\u00E3o do Feriado', value: FeriadoDescricao, onChange: function (event) { return setFeriadoDescricao(event.target.value); }, inputProps: { maxLength: 150 }, disabled: DESABILITAR_CAMPOS }) })), _jsx(Grid, __assign({ item: true, xs: 12, sm: 2 }, { children: _jsx(InputDados, { id: 'feriado_data', label: 'Data (DD/MM)', value: FeriadoData, mask: '99/99', onChange: function (event) { return setFeriadoData(event.target.value); }, disabled: DESABILITAR_CAMPOS }) })), _jsx(Grid, __assign({ item: true, xs: 12, sm: 2 }, { children: _jsx(InputDados, __assign({ select: true, id: 'feriado_abrangencia', label: 'Abrang\u00EAncia', value: FeriadoAbrangencia, onChange: function (event) { return onChangeAbrangencia(event.target.value); }, disabled: DESABILITAR_CAMPOS }, { children: ABRANGENCIAS.map(function (a) { return (_jsx(MenuItem, __assign({ value: a }, { children: a }), a)); }) })) })), _jsx(Grid, __assign({ item: true, xs: 12, sm: 2 }, { children: _jsxs(InputDados, __assign({ select: true, id: 'feriado_uf', label: 'Estado (UF)', value: FeriadoUF, onChange: function (event) { return onChangeEstadoFeriado(event.target.value); }, disabled: DESABILITAR_CAMPOS || FeriadoAbrangencia === 'Federal' }, { children: [_jsx(MenuItem, __assign({ value: '' }, { children: _jsx("em", { children: "Selecione" }) })), EstadosDisponiveis.map(function (e) { return (_jsx(MenuItem, __assign({ value: e.sigla }, { children: e.sigla }), e.id)); })] })) })), _jsx(Grid, __assign({ item: true, xs: 12, sm: 2 }, { children: _jsxs(InputDados, __assign({ select: true, id: 'feriado_cidade', label: 'Cidade', value: FeriadoCidade, onChange: function (event) { return setFeriadoCidade(event.target.value); }, disabled: DESABILITAR_CAMPOS || FeriadoAbrangencia !== 'Municipal' }, { children: [_jsx(MenuItem, __assign({ value: '' }, { children: _jsx("em", { children: "Selecione" }) })), CidadesFeriado.map(function (c) { return (_jsx(MenuItem, __assign({ value: c.id }, { children: c.nome }), c.id)); })] })) })), _jsx(Grid, __assign({ item: true, xs: 12, sm: 4 }, { children: _jsx(FormControlLabel, { control: _jsx(Checkbox, { checked: FeriadoSabadoTrabalhado, onChange: function (event) { return setFeriadoSabadoTrabalhado(event.target.checked); }, disabled: DESABILITAR_CAMPOS }), label: 'S\u00E1bado Trabalhado? (Abater Feriado)' }) })), _jsx(Grid, __assign({ item: true, xs: 12, sm: 4 }, { children: _jsx(BotaoAuxiliar, __assign({ backgroundColor: 'principal.main', onClick: salvarFeriado, disabled: DESABILITAR_CAMPOS }, { children: "Salvar Feriado no Calend\u00E1rio" })) }))] })), _jsx(Box, __assign({ sx: { mt: 3 } }, { children: _jsx(TableContainer, __assign({ component: Paper, variant: 'outlined' }, { children: _jsxs(Table, __assign({ size: 'small' }, { children: [_jsx(TableHead, { children: _jsxs(TableRow, { children: [_jsx(TableCell, { children: "Descri\u00E7\u00E3o" }), _jsx(TableCell, { children: "Data" }), _jsx(TableCell, { children: "Abrang\u00EAncia" }), _jsx(TableCell, { children: "Local" }), _jsx(TableCell, __assign({ align: 'right' }, { children: "A\u00E7\u00F5es" }))] }) }), _jsxs(TableBody, { children: [ListaFeriados.length === 0 && (_jsx(TableRow, { children: _jsx(TableCell, __assign({ colSpan: 5, align: 'center' }, { children: "Nenhum feriado cadastrado." })) })), ListaFeriados.map(function (f) { return (_jsxs(TableRow, { children: [_jsx(TableCell, { children: f.descricao }), _jsx(TableCell, { children: "".concat(pad2(f.dia), "/").concat(pad2(f.mes)) }), _jsx(TableCell, { children: f.abrangencia }), _jsx(TableCell, { children: getLocalFeriado(f) }), _jsx(TableCell, __assign({ align: 'right' }, { children: _jsx(IconButton, __assign({ "aria-label": 'excluir feriado', color: 'error', onClick: function () { return excluirFeriadoLinha(f.id); }, disabled: DESABILITAR_CAMPOS }, { children: _jsx(DeleteOutlineIcon, {}) })) }))] }, f.id)); })] })] })) })) }))] }))), _jsxs(BoxBotoes, { children: [(MODOS.ALTERAR == modo || MODOS.CADASTRAR == modo) && _jsx(BotaoSalvar, { label: 'SALVAR PAR\u00C2METROS', onClick: salvarDados }), MODOS.VISUALIZAR == modo && _jsx(BotaoEditar, { onClick: editarRegistro, disabled: !AcoesFuncionalidade['ALTERAR'] || REGISTRO_INATIVO }), MODOS.EXCLUIR == modo && _jsx(BotaoExcluir, { onClick: excluirRegistro, disabled: !AcoesFuncionalidade['EXCLUIR'] }), _jsx(BotaoFechar, { modo: modo })] })] })), loading && _jsx(Loading, {})] })) })));
};
export default ParametrosParametrosFolhasEditar;
